import { useEffect } from 'react';
import { useAuthStore } from '@/shared/lib';
import { usePermissions } from '@/entities/permission';

export const PermissionProvider = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const token = useAuthStore((state) => state.token);

  const { refetch } = usePermissions();

  useEffect(() => {
    if (isAuthenticated && token) {
      refetch();
    }
  }, [isAuthenticated, token, refetch]);

  return <>{children}</>;
};
